import Container from "./Container";

export default function Contact(){
    return <div className="contact py-4">
            <Container classes="container">
         <div class="form">
    <h1 class="text-uppercase text-md-center">Get in touch with us</h1>
    <p class="text-md-center">There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which Ipsum slightly believable</p>
    <div class="d-flex justify-content-center">
        <input type="text" class="" placeholder="Your Email Address" />
        <button class="text-uppercase">Subscript</button>
    </div>
</div>
    </Container>
        </div>
}